import csrfTokenService from '@app/helpers/csrfTokenService';

const USER_DELETED_MESSAGE = 'User deleted';

function responseObserver($q: ng.IQService, $window: ng.IWindowService) {
  return {
    responseError(errorResponse: {
      status: number;
      data: typeof USER_DELETED_MESSAGE | { type?: string; message?: string };
    }) {
      if (errorResponse.status === 403) {
        if (errorResponse.data === USER_DELETED_MESSAGE) {
          $window.localStorage.setItem('loggedOut', 'true');
          $window.location.href = '/logoutpage';
        } else if (!errorResponse.data?.type) {
          $window.location = '/403.html' as todo;
        }
      }
      if (
        // @ts-expect-error csrf error can be 403(when coming from post / put requests from routes) or 500 when coming from csrf library
        errorResponse.data?.message ===
        csrfTokenService.INVALID_CSRF_ERROR_MESSAGE
      ) {
        csrfTokenService.clearCsrfCache();
      }
      return $q.reject(errorResponse);
    },
  };
}

responseObserver.$inject = ['$q', '$window'];

export default responseObserver;
